import { FC, ReactNode, MouseEvent } from 'react'
import { DrawerContainer, Drawer, CloseButtonContainer, DrawerContent } from './styles'
import { IoClose } from 'react-icons/io5'

interface RightDrawerProps {
  children?: ReactNode;
  open: boolean;
  toggle: () => void;
}

const RightDrawer: FC<RightDrawerProps> = ({ children, open, toggle }) => {
  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()
    toggle()
  }

  return (
    <DrawerContainer open={open} onClick={handleClick}>
      <Drawer onClick={e => e.stopPropagation()} open={open}>
        <CloseButtonContainer onClick={handleClick}>
          <IoClose />
        </CloseButtonContainer>
        <DrawerContent>
          {children}
        </DrawerContent>
      </Drawer>
    </DrawerContainer>
  )
}

export default RightDrawer